import { useQuery } from '@tanstack/react-query';
import { fetchCurrentRelease, releasesKeys } from '../api';

// La release actual es cache MUY largo — solo cambia cuando publicamos algo
// nuevo, y las pushes hacen reload de todo. 1h stale y 24h gc bastan.
export function useCurrentRelease() {
  return useQuery({
    queryKey: releasesKeys.current(),
    queryFn: fetchCurrentRelease,
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
  });
}
